import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1879197e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-me__wrapper" }
const _hoisted_2 = { class: "about-me" }

import ContentPage from "../ContentPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutMeView',
  setup(__props) {

const getBirthYear = () => {
  let birthdateTimeStamp = new Date(1997, 5, 25);
  let diff = new Date().getTime() - birthdateTimeStamp.getTime();
  let currentAge = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  // Divide by 1000*60*60*24*365.25

  return currentAge;
};

const getSpanArray = () => {
  return [
    "Hello there_",
    "I am Timothy van der Veen",
    `a ${getBirthYear()} year old`,
    "fullstack developer",
    "from Groningen_",
    "In the captivating",
    "realm of web development",
    "variables speak",
    "louder than words_",
    "Instead of writing a resume",
    "full of half-truths",
    "and exaggerated claims",
    "I prefer to let",
    "my skills do the talking_",
  ];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentPage, {
    full: true,
    class: "content-page__about-me"
  }, {
    full: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSpanArray(), (spanText, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: "secondary-font"
            }, _toDisplayString(spanText), 1))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})